// @flow
import React from "react"
import { Text } from "componentsStyled/Typography/Texts"
import type { HOC } from "recompose"
import withRouter from "hoc/withRouter"
import urls from "data/router/urls"
import Button from "components/Button"
import { EmptyStateWrap } from "./styled"

const EmptyState = ({ history }) => (
  <EmptyStateWrap>
    <Text>Nothing here!</Text>
    <Button onClick={() => history.push(urls.products)}>
      Reserve a product
    </Button>
  </EmptyStateWrap>
)

const enhancer: HOC<*, {||}> = withRouter

export default enhancer(EmptyState)



// WEBPACK FOOTER //
// ./src/components/ReservationList/EmptyState/index.js